/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const DraftMeta: core.serialization.ObjectSchema<serializers.DraftMeta.Raw, Truvity.DraftMeta> =
    core.serialization.object({
        subject: core.serialization.string().optional(),
        validFrom: core.serialization.property('valid_from', core.serialization.date().optional()),
        validUntil: core.serialization.property('valid_until', core.serialization.date().optional()),
    });

export declare namespace DraftMeta {
    export interface Raw {
        subject?: string | null;
        valid_from?: string | null;
        valid_until?: string | null;
    }
}
